const audioCache = new Map<string, HTMLAudioElement>();

export const getOrCreateAudio = (src: string): HTMLAudioElement => {
  if (audioCache.has(src)) {
    const cachedAudio = audioCache.get(src)!;
    cachedAudio.currentTime = 0;
    return cachedAudio;
  }

  const audio = new Audio();
  audio.preload = 'metadata';
  audio.src = src;
  audio.load();

  audioCache.set(src, audio);
  return audio;
};

export const clearAudioCache = (): void => {
  audioCache.clear();
};

export const removeAudioFromCache = (src: string): void => {
  audioCache.delete(src);
};
